var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle2, _path14, _path15, _path16, _path17, _path18, _path19, _circle3, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportVideoTutorialsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 139.516 84",
    width: 139.516,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_video_tutorials_icon_svg__a",
    gradientUnits: "objectBoundingBox",
    x2: 1,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3a3eef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12b9d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m499.6 211.825a2.121 2.121 0 0 1 -2.11 2.132h-92.84a2.121 2.121 0 0 1 -2.11-2.132v-63.418a2.121 2.121 0 0 1 2.11-2.132h92.843a2.121 2.121 0 0 1 2.11 2.132z",
    fill: "#e6e6e6",
    transform: "translate(-360.087 -146.275)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m505.73 217.879a2.062 2.062 0 0 1 -2.062 2.062h-90.686a2.062 2.062 0 0 1 -2.062-2.062v-61.312a2.062 2.062 0 0 1 2.062-2.062h90.69a2.062 2.062 0 0 1 2.058 2.062z",
    fill: "#fff",
    transform: "translate(-367.308 -153.367)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m342.8 27.48h85.213a1.224 1.224 0 0 1 1.227 1.22v57.43a1.224 1.224 0 0 1 -1.224 1.224h-85.216a1.224 1.224 0 0 1 -1.224-1.224v-57.43a1.224 1.224 0 0 1 1.224-1.22z",
    fill: "#e6e6e6",
    transform: "translate(-294.345 -23.68)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m350.6 37.44h82.963a1.224 1.224 0 0 1 1.224 1.224v54.362a1.224 1.224 0 0 1 -1.224 1.224h-82.963a1.224 1.224 0 0 1 -1.224-1.224v-54.362a1.224 1.224 0 0 1 1.224-1.224z",
    fill: "#fff",
    transform: "translate(-301.067 -32.263)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m826.5 340.166a2.332 2.332 0 0 1 -.948-.2 1.15 1.15 0 0 1 -.2-.112l-6.029-4.244a2.333 2.333 0 0 1 -.99-1.907v-5.788a2.332 2.332 0 0 1 .99-1.907l6.03-4.244a1.152 1.152 0 0 1 .2-.112 2.333 2.333 0 0 1 3.28 2.132v14.052a2.333 2.333 0 0 1 -2.333 2.333z",
    fill: "#3f3d56",
    transform: "translate(-718.383 -297.225)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m636.276 334.207h-16.816c-3.431 0-6.211-2.221-6.215-4.957v-11.08c0-2.737 2.784-4.954 6.215-4.957h16.86c3.406 0 6.167 2.205 6.171 4.922v11.115c-.004 2.737-2.784 4.95-6.215 4.957z",
    fill: "#3f3d56",
    transform: "translate(-541.655 -290.128)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 124.576,
    cy: 53.489,
    fill: "#e6e6e6",
    r: 5.001
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m989.39 518.011-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179l-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179z",
    fill: "#fff",
    transform: "translate(-862.216 -464.611)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m344.6 266.825a2.121 2.121 0 0 1 -2.11 2.132h-92.84a2.121 2.121 0 0 1 -2.11-2.132v-63.418a2.121 2.121 0 0 1 2.11-2.132h92.843a2.121 2.121 0 0 1 2.11 2.132z",
    fill: "#e6e6e6",
    transform: "translate(-226.521 -193.669)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m350.73 272.879a2.062 2.062 0 0 1 -2.062 2.062h-90.686a2.062 2.062 0 0 1 -2.062-2.062v-61.312a2.062 2.062 0 0 1 2.062-2.062h90.69a2.062 2.062 0 0 1 2.058 2.062z",
    fill: "#fff",
    transform: "translate(-233.742 -200.761)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m187.8 82.48h85.213a1.224 1.224 0 0 1 1.227 1.22v57.43a1.224 1.224 0 0 1 -1.224 1.224h-85.216a1.224 1.224 0 0 1 -1.224-1.224v-57.43a1.224 1.224 0 0 1 1.224-1.22z",
    fill: "#e6e6e6",
    transform: "translate(-160.779 -71.074)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m195.6 92.44h82.963a1.224 1.224 0 0 1 1.224 1.224v54.362a1.224 1.224 0 0 1 -1.224 1.224h-82.963a1.224 1.224 0 0 1 -1.224-1.224v-54.362a1.224 1.224 0 0 1 1.224-1.224z",
    fill: "#fff",
    transform: "translate(-167.501 -79.657)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m671.5 395.166a2.332 2.332 0 0 1 -.948-.2 1.147 1.147 0 0 1 -.2-.112l-6.029-4.244a2.333 2.333 0 0 1 -.99-1.907v-5.788a2.332 2.332 0 0 1 .99-1.907l6.03-4.244a1.154 1.154 0 0 1 .2-.112 2.333 2.333 0 0 1 3.28 2.132v14.052a2.333 2.333 0 0 1 -2.333 2.333z",
    fill: "#3f3d56",
    transform: "translate(-584.817 -344.619)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m481.276 389.207h-16.816c-3.431 0-6.211-2.221-6.215-4.957v-11.08c0-2.737 2.784-4.954 6.215-4.957h16.86c3.406 0 6.167 2.205 6.171 4.922v11.115c-.004 2.737-2.784 4.95-6.215 4.957z",
    fill: "#3f3d56",
    transform: "translate(-408.089 -337.522)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.142,
    cy: 61.095,
    fill: "#e6e6e6",
    r: 5.001
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m834.394 573.011-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179l-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179z",
    fill: "#fff",
    transform: "translate(-728.654 -512.005)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m192.6 329.825a2.121 2.121 0 0 1 -2.11 2.132h-92.84a2.121 2.121 0 0 1 -2.11-2.132v-63.418a2.121 2.121 0 0 1 2.11-2.132h92.843a2.121 2.121 0 0 1 2.11 2.132z",
    fill: "#e6e6e6",
    transform: "translate(-95.54 -247.958)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m198.73 335.879a2.062 2.062 0 0 1 -2.062 2.062h-90.686a2.062 2.062 0 0 1 -2.062-2.062v-61.312a2.062 2.062 0 0 1 2.062-2.062h90.69a2.062 2.062 0 0 1 2.058 2.062z",
    fill: "#fff",
    transform: "translate(-102.761 -255.05)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m35.8 145.48h85.213a1.224 1.224 0 0 1 1.224 1.224v57.426a1.224 1.224 0 0 1 -1.224 1.224h-85.213a1.224 1.224 0 0 1 -1.224-1.224v-57.43a1.224 1.224 0 0 1 1.224-1.22z",
    fill: "#e6e6e6",
    transform: "translate(-29.798 -125.363)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m43.6 155.44h82.963a1.224 1.224 0 0 1 1.224 1.224v54.362a1.224 1.224 0 0 1 -1.224 1.224h-82.963a1.224 1.224 0 0 1 -1.224-1.224v-54.362a1.224 1.224 0 0 1 1.224-1.224z",
    fill: "#fff",
    transform: "translate(-36.52 -133.945)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m6.215 21c-3.431-.007-6.215-2.225-6.215-4.962v-11.08c0-2.736 2.784-4.958 6.215-4.958h16.861c3.406 0 6.166 2.2 6.17 4.922v.853c.034-.027.069-.053.1-.078l6.03-4.244a1.066 1.066 0 0 1 .2-.112 2.332 2.332 0 0 1 3.28 2.131v14.052a2.332 2.332 0 0 1 -2.332 2.332 2.331 2.331 0 0 1 -.948-.2 1.066 1.066 0 0 1 -.2-.112l-6.026-4.244c-.035-.025-.07-.051-.1-.078v.816c0 2.737-2.783 4.955-6.214 4.958z",
    fill: "url(#support_video_tutorials_icon_svg__a)",
    transform: "translate(29.136 39.402)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.123,
    cy: 69.807,
    fill: "#3f3d56",
    r: 5.001
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m682.394 636.011-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179l-3.987-2.3a.1.1 0 0 0 -.155.09v4.6a.1.1 0 0 0 .155.09l3.987-2.3a.1.1 0 0 0 0-.179z",
    fill: "#fff",
    transform: "translate(-597.673 -566.293)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportVideoTutorialsIcon);
export default __webpack_public_path__ + "static/media/support_video_tutorials_icon.d936717a87d5302ac2f391b1f97d62c2.svg";
export { ForwardRef as ReactComponent };